export default __webpack_public_path__ + "static/media/cart.a67ac9cf.svg";